import { Link } from "react-router-dom";
import { FileText } from "lucide-react";

const UPDATED = "June 2026";

export default function Terms() {
  return (
    <div className="pt-28 pb-24 max-w-3xl mx-auto px-5" data-testid="terms-page">
      <p className="font-mono-label uppercase tracking-[0.3em] text-xs text-[#D4AF37] flex items-center gap-2"><FileText size={14} /> Legal</p>
      <h1 className="font-display text-4xl md:text-5xl text-white mt-3 mb-2">Terms &amp; Conditions</h1>
      <p className="text-white/40 text-sm mb-10">Last updated: {UPDATED}</p>

      <div className="space-y-8 text-white/70 text-sm leading-relaxed">
        <section>
          <p>These Terms &amp; Conditions ("Terms") govern your use of the XMD Productions website and booking services. By booking a session or using our site, you agree to these Terms.</p>
        </section>

        <Section title="Bookings & Payment">
          <p>Bookings are requested online and are held as <em>pending</em> until payment is completed. A booking is confirmed only once payment is successfully processed through our payment providers (Stripe or PayPal). Prices, hourly rates, and equipment add-on fees are shown at the time of booking and are calculated and finalized by us.</p>
        </Section>

        <Section title="Cancellations & Rescheduling">
          <p>To cancel or reschedule, use the "My Bookings" page or contact us directly. Cancellation and rescheduling requests are reviewed by our studio and may be subject to our then-current policies. Refund eligibility depends on notice given and the nature of the booked service.</p>
        </Section>

        <Section title="SMS / Messaging Terms">
          <p>By opting in to SMS on our booking form, you agree to receive transactional text messages (appointment confirmations, reminders, and updates) from XMD Productions at the phone number you provide. Opt-in is optional and not required to book.</p>
          <ul className="list-disc pl-5 space-y-1 mt-3">
            <li>Message frequency varies based on your bookings and interactions.</li>
            <li>Message and data rates may apply.</li>
            <li>Reply <span className="text-[#D4AF37]">STOP</span> at any time to unsubscribe; reply <span className="text-[#D4AF37]">HELP</span> for help.</li>
            <li>Carriers are not liable for delayed or undelivered messages.</li>
          </ul>
          <p className="mt-3">For details on how we handle your mobile information, see our <Link to="/privacy" className="text-[#D4AF37] hover:underline">Privacy Policy</Link>. We do not share mobile opt-in data or consent with third parties for marketing purposes.</p>
        </Section>

        <Section title="Use of Our Services">
          <p>You agree to provide accurate information and to use our site and studio lawfully. We reserve the right to refuse or cancel service for misuse, non-payment, or violation of these Terms.</p>
        </Section>

        <Section title="Intellectual Property">
          <p>All content on this site, including the XMD Productions name, logo, and media, is owned by or licensed to XMD Productions and may not be used without permission. Ownership and usage rights of work produced during a booked session are governed by the agreement for that specific project.</p>
        </Section>

        <Section title="Limitation of Liability">
          <p>To the maximum extent permitted by law, XMD Productions is not liable for indirect, incidental, or consequential damages arising from the use of our site or services. Our total liability for any claim is limited to the amount you paid for the applicable booking.</p>
        </Section>

        <Section title="Changes to These Terms">
          <p>We may update these Terms from time to time. Continued use of our services after changes take effect constitutes acceptance of the updated Terms.</p>
        </Section>

        <Section title="Contact Us">
          <p>XMD Productions<br />3020 High Ridge Rd, Suite 600A, Boynton Beach, FL 33426<br />Phone: +1 561-503-7743<br />Email: <a href="mailto:info@xmdproductions.com" className="text-[#D4AF37] hover:underline">info@xmdproductions.com</a></p>
        </Section>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <section>
      <h2 className="font-display text-xl text-white mb-2">{title}</h2>
      {children}
    </section>
  );
}
